import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "./pages/Home";
import Store from "./pages/Store";
import Subscriptions from "./pages/Subscriptions";
import KingdomGuard from "./pages/KingdomGuard";
import Media from "./pages/Media";
import About from "./pages/About";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import AdminDashboard from "./pages/AdminDashboard";
import BookChaptersView from "./pages/BookChaptersView";
import DynamicEbookReader from "./pages/DynamicEbookReader";
import Library from "./pages/Library";
import AuthCallback from "./pages/AuthCallback";
import EbookReader from "./pages/EbookReader";
import ProloguePage from "./pages/ProloguePage";
import MindMap from "./pages/MindMap";
import PuzzleExplorer from "./pages/PuzzleExplorer";
import AdminPuzzleEditor from "./pages/AdminPuzzleEditor";
import AdminAppendixEditor from "./pages/AdminAppendixEditor";
import GITInvestigator from "./pages/GITInvestigator";
import EscortGuardAdmin from "./pages/EscortGuardAdmin";
import BookPurchase from "./pages/BookPurchase";
import AdminPricing from "./pages/AdminPricing";
import AdminSiteConfig from "./pages/AdminSiteConfig";
import Leaderboard from "./pages/Leaderboard";
import ReadingStreaks from "./pages/ReadingStreaks";
import GITExplorer from "./pages/GITExplorer";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminPodcastStudio from "./pages/AdminPodcastStudio";
import AdminLessonEditor from "./pages/AdminLessonEditor";
import TeamManagement from "./pages/TeamManagement";
import WelcomeBeta from "./pages/WelcomeBeta";
import AdminLessonContent from "./pages/AdminLessonContent";
import HelpGuide from "./pages/HelpGuide";
import DynamicLesson from "./pages/lessons/DynamicLesson";
import GIT101Lesson from "./pages/lessons/GIT101";
import BlueprintsLesson from "./pages/lessons/Blueprints";
import RecapitulationLesson from "./pages/lessons/Recapitulation";
import Corner1Lesson from "./pages/lessons/Corner1";
import Corner2Lesson from "./pages/lessons/Corner2";
import Corner3Lesson from "./pages/lessons/Corner3";
import Corner4Lesson from "./pages/lessons/Corner4";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { BookProvider } from "./context/BookContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BookProvider>
          <ThemeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PuzzleExplorer />} />
              <Route path="/welcome" element={<Home />} />
              <Route path="/git-explorer" element={<GITExplorer />} />
              <Route path="/store" element={<Store />} />
              <Route path="/store/:category" element={<Store />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
              <Route path="/kingdom-guard" element={<KingdomGuard />} />
              <Route path="/media" element={<Media />} />
              <Route path="/about" element={<About />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/checkout/cancel" element={<CheckoutCancel />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/ebook/prologue" element={<ProloguePage />} />
              <Route 
                path="/ebook" 
                element={
                  <ProtectedRoute>
                    <EbookReader />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/ebook/:chapterSlug" 
                element={
                  <ProtectedRoute>
                    <EbookReader />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/account" 
                element={
                  <ProtectedRoute>
                    <Account />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/books/:bookId" 
                element={
                  <ProtectedRoute>
                    <BookChaptersView />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/library" 
                element={
                  <ProtectedRoute>
                    <Library />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/mindmap" 
                element={
                  <ProtectedRoute>
                    <MindMap />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/puzzle" 
                element={<PuzzleExplorer />}
              />
              <Route 
                path="/welcome-beta" 
                element={<WelcomeBeta />}
              />
              <Route 
                path="/admin/puzzle" 
                element={
                  <ProtectedRoute>
                    <AdminPuzzleEditor />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/appendices" 
                element={
                  <ProtectedRoute>
                    <AdminAppendixEditor />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/ebooks/:bookId/:chapterNum" 
                element={
                  <ProtectedRoute>
                    <DynamicEbookReader />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/git-investigator" 
                element={
                  <ProtectedRoute>
                    <GITInvestigator />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/escort-guard" 
                element={
                  <ProtectedRoute>
                    <EscortGuardAdmin />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/buy" 
                element={<BookPurchase />}
              />
              <Route 
                path="/leaderboard" 
                element={<Leaderboard />}
              />
              <Route 
                path="/streaks" 
                element={
                  <ProtectedRoute>
                    <ReadingStreaks />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/pricing" 
                element={
                  <ProtectedRoute>
                    <AdminPricing />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/site-config" 
                element={
                  <ProtectedRoute>
                    <AdminSiteConfig />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/analytics" 
                element={
                  <ProtectedRoute>
                    <AdminAnalytics />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/podcast" 
                element={
                  <ProtectedRoute>
                    <AdminPodcastStudio />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/lessons" 
                element={
                  <ProtectedRoute>
                    <AdminLessonEditor />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/team" 
                element={
                  <ProtectedRoute>
                    <TeamManagement />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin/lesson-content/:moduleKey" 
                element={
                  <ProtectedRoute>
                    <AdminLessonContent />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/help" 
                element={
                  <ProtectedRoute>
                    <HelpGuide />
                  </ProtectedRoute>
                } 
              />
              <Route path="/lesson/git-101" element={<GIT101Lesson />} />
              <Route path="/lesson/blueprints" element={<BlueprintsLesson />} />
              <Route path="/lesson/recapitulation" element={<RecapitulationLesson />} />
              <Route path="/lesson/corner1" element={<Corner1Lesson />} />
              <Route path="/lesson/corner2" element={<Corner2Lesson />} />
              <Route path="/lesson/corner3" element={<Corner3Lesson />} />
              <Route path="/lesson/corner4" element={<Corner4Lesson />} />
              <Route path="/lesson/:moduleKey" element={<DynamicLesson />} />
            </Routes>
          </BrowserRouter>
          </ThemeProvider>
          </BookProvider>
          <Toaster />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
